export default "__VITE_ASSET__Bp2w5SfY__"